import { css, type Theme } from "@emotion/react";

export const card = (theme: Theme) => css`
  background-color: ${theme.ds5.surface.level0};
  border: ${theme.ds5.box.borderWeight} solid ${theme.ds5.neutral.divider};
  border-radius: ${theme.ds5.radius.surface.xlarge};
  padding: ${theme.ds5.padding.dynamic[1000]};
`;

export const form = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.ds5.spacing.gap.medium};
`;

export const submitRow = (theme: Theme) => css`
  margin-top: ${theme.ds5.spacing.gap.small};
`;

export const signInPrompt = (theme: Theme) => css`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: center;
  gap: ${theme.ds5.spacing.gap.xsmall};
`;
